import { environment } from './../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Cintillo } from '../../../entities/cintillo/imagenes';

@Injectable({
  providedIn: 'root'
})
export class ImagenesService {

  constructor(private http: HttpClient) { }


  getPromociones(): Observable<any> {
		return this.http.get<any>(`${environment.API_SECURITY}/api/Promociones/PromocionActiva`);
	}
  
}
